import React from "react";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

export default function StoreDetailSkeleton() {
  return (
    <Grid container spacing={2}>
      {/* Banner Skeleton */}
      <Grid item xs={12} style={{ height: "20rem" }}>
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Grid>

      {/* Menu Skeleton */}
      <Grid item xs={12} container>
        <Grid item xs={6}>
          <Skeleton variant="circular" width={50} height={50} />
          <Skeleton variant="text" width="60%" height={30} />
        </Grid>
        <Grid item xs={6} textAlign="left">
          <Skeleton variant="text" width="30%" height={20} />
        </Grid>
      </Grid>

      {/* Categories Skeleton */}
      <Grid item xs={12} container spacing={2}>
        <Grid item xs={12} md={6}>
          <Skeleton variant="text" width="40%" height={30} />
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={6} sm={3} key={item}>
                <Skeleton variant="rectangular" width="100%" height={100} />
              </Grid>
            ))}
          </Grid>
          <Skeleton variant="text" width="90%" height={20} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Skeleton variant="text" width="70%" height={20} />
          <Skeleton variant="text" width="90%" height={60} />
        </Grid>
      </Grid>

      {/* Table Skeleton */}
      <Grid item xs={12}>
        <Skeleton variant="text" width="30%" height={30} />
        <Skeleton variant="rectangular" width="100%" height={200} />
      </Grid>
    </Grid>
  );
}
